module.exports = __webpack_public_path__ + "static/media/erik_kimsey__software_engineer.f596ad7b.pdf";